const IDENTITY_STORAGE_KEY = 'check-insta-channel-fit:identity';

export interface IdentityParams {
  email?: string;
  uid?: string;
}

function readFromStorage(): IdentityParams {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(IDENTITY_STORAGE_KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return {};
    const { email, uid } = parsed as Record<string, unknown>;
    return {
      email: typeof email === 'string' && email ? email : undefined,
      uid: typeof uid === 'string' && uid ? uid : undefined,
    };
  } catch {
    return {};
  }
}

function writeToStorage(identity: IdentityParams): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(IDENTITY_STORAGE_KEY, JSON.stringify(identity));
  } catch {
    // localStorage nicht verfügbar -- Identity bleibt nur für diese Sitzung im Speicher.
  }
}

/**
 * Liest die optionalen Query-Parameter `email` und `uid` aus der aktuellen URL (beide sind
 * freiwillig, keiner ist erforderlich) und merged sie mit einer zuvor erfassten Identity aus
 * `localStorage` -- neue Werte überschreiben alte. Wird einmalig beim App-Start aufgerufen, damit
 * die Werte auch nach internem Routing (ohne Query-String in der URL) noch für spätere Events wie
 * `result_shown` verfügbar sind.
 */
export function captureIdentityParams(): IdentityParams {
  const stored = readFromStorage();
  if (typeof window === 'undefined') return stored;

  const params = new URLSearchParams(window.location.search);
  const email = params.get('email')?.trim();
  const uid = params.get('uid')?.trim();

  if (!email && !uid) return stored;

  const merged: IdentityParams = {
    email: email || stored.email,
    uid: uid || stored.uid,
  };
  writeToStorage(merged);
  return merged;
}
